import React, { Component } from "react";
import { Card, Table, Button, Row, Col, Modal, Form, Alert } from "react-bootstrap";
import { FaPlus, FaRegEdit, FaTrash, FaCheck } from "react-icons/fa";
import api from "../../services/api";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Editor from '@monaco-editor/react';
import Paginacao from '../../common/pagination';

class ProgramaRegras extends Component {
    constructor(props) {
        super(props);

        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listRegras: [],
            loading: true,
            loadingModal: false,
            error: '',
            page_numb: 1,
            
            // Modal
            showModal: false,
            modalTitulo: '',
            regraEditando: null,
            
            // Campos do formulário
            id: null,
            tipos: [],
            max_executions: '',
            regrasJson: '[]',
            acoesJson: '[]',
            
            // Erros de validação
            tiposError: '',
            maxExecutionsError: '',
            regrasJsonError: '',
            acoesJsonError: '',
        };

        this.tiposDisponiveis = [
            { value: 'auto', label: 'Auto' },
            { value: 'cron', label: 'Cron' }
        ];
    }

    componentDidMount() {
        this.carregarRegras(this.state.page_numb);
    }

    carregarRegras = (page_numb = 1) => {
        const { programaId } = this.props;

        if (!programaId) {
            this.setState({ loading: false, error: 'ID do programa não informado' });
            return;
        }

        this.setState({ loading: true, error: '' });

        api.get(`/programas/regras/?programa_id=${programaId}&page=${page_numb}`)
            .then(response => {
                this.setState({
                    listRegras: response.data,
                    loading: false,
                    error: '',
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao carregar regras do programa';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg,
                });
            });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.carregarRegras(num_page);
    }

    // Gera um resumo legível do JSON
    gerarResumoJson = (json, maxLength = 80) => {
        if (!json || (Array.isArray(json) && json.length === 0) || (typeof json === 'object' && Object.keys(json).length === 0)) {
            return <span className="text-muted">Vazio</span>;
        }

        try {
            let resumo = '';

            if (Array.isArray(json)) {
                // Se for array, mostra quantidade e preview dos primeiros itens
                const qtd = json.length;
                const preview = json.slice(0, 2).map(item => {
                    if (typeof item === 'object' && item !== null) {
                        // Pega as primeiras chaves do objeto
                        const keys = Object.keys(item).slice(0, 3);
                        return keys.map(k => `${k}: ${this.formatarValor(item[k])}`).join(', ');
                    }
                    return String(item);
                }).join(' | ');

                resumo = `[${qtd} item${qtd > 1 ? 's' : ''}] ${preview}`;
            } else if (typeof json === 'object') {
                // Se for objeto, mostra as primeiras chaves e valores
                const keys = Object.keys(json).slice(0, 4);
                resumo = keys.map(k => `${k}: ${this.formatarValor(json[k])}`).join(', ');
            } else {
                resumo = String(json);
            }

            // Trunca se muito longo
            if (resumo.length > maxLength) {
                resumo = resumo.substring(0, maxLength) + '...';
            }

            return <span title={JSON.stringify(json, null, 2)}>{resumo}</span>;
        } catch (e) {
            return <span className="text-muted">Erro ao ler JSON</span>;
        }
    };

    formatarValor = (valor) => {
        if (valor === null || valor === undefined) return 'null';
        if (typeof valor === 'boolean') return valor ? 'true' : 'false';
        if (typeof valor === 'object') return Array.isArray(valor) ? `[${valor.length}]` : '{...}';
        if (typeof valor === 'string' && valor.length > 20) return valor.substring(0, 20) + '...';
        return String(valor);
    };

    abrirModalNovo = () => {
        this.setState({
            showModal: true,
            modalTitulo: 'Adicionar Regra',
            regraEditando: null,
            id: null,
            tipos: [],
            max_executions: '',
            regrasJson: '[]',
            acoesJson: '[]',
            tiposError: '',
            maxExecutionsError: '',
            regrasJsonError: '',
            acoesJsonError: '',
        });
    };

    abrirModalEditar = (regra) => {
        // Converte string de tipos para array
        const tiposArray = regra.tipos ? regra.tipos.split(',').map(t => t.trim()) : [];

        this.setState({
            showModal: true,
            modalTitulo: `Editar Regra #${regra.id}`,
            regraEditando: regra,
            id: regra.id,
            tipos: tiposArray,
            max_executions: regra.max_executions != null ? String(regra.max_executions) : '',
            regrasJson: regra.regras ? JSON.stringify(regra.regras, null, 4) : '[]',
            acoesJson: regra.acoes ? JSON.stringify(regra.acoes, null, 4) : '[]',
            tiposError: '',
            maxExecutionsError: '',
            regrasJsonError: '',
            acoesJsonError: '',
        });
    };

    fecharModal = () => {
        this.setState({
            showModal: false,
            regraEditando: null,
            id: null,
            tipos: [],
            max_executions: '',
            regrasJson: '[]',
            acoesJson: '[]',
            tiposError: '',
            maxExecutionsError: '',
            regrasJsonError: '',
            acoesJsonError: '',
        });
    };

    handleTipoChange = (tipo, checked) => {
        this.setState(prevState => {
            let novosTipos = [...prevState.tipos];
            
            if (checked) {
                if (!novosTipos.includes(tipo)) {
                    novosTipos.push(tipo);
                }
            } else {
                novosTipos = novosTipos.filter(t => t !== tipo);
            }

            return { tipos: novosTipos, tiposError: '' };
        });
    };

    handleRegrasJsonChange = (value) => {
        this.setState({ regrasJson: value || '', regrasJsonError: '' });
    };

    handleAcoesJsonChange = (value) => {
        this.setState({ acoesJson: value || '', acoesJsonError: '' });
    };
    
    handleMaxExecutionsChange = (e) => {
        const value = e.target.value;
        // Permite apenas vazio ou números inteiros positivos
        if (value === '' || /^\d+$/.test(value)) {
            this.setState({ max_executions: value, maxExecutionsError: '' });
        }
    };

    validarFormulario = () => {
        let valido = true;

        // Validar tipos
        if (this.state.tipos.length === 0) {
            this.setState({ tiposError: 'Selecione pelo menos um tipo' });
            valido = false;
        }
        
        // Validar max_executions (opcional, mas se preenchido deve ser número positivo)
        if (this.state.max_executions !== '' && (isNaN(this.state.max_executions) || parseInt(this.state.max_executions) < 1)) {
            this.setState({ maxExecutionsError: 'Informe um número inteiro positivo ou deixe em branco para sem limite' });
            valido = false;
        }

        // Validar JSON de regras
        try {
            JSON.parse(this.state.regrasJson);
        } catch (e) {
            this.setState({ regrasJsonError: 'JSON inválido. Verifique a sintaxe.' });
            valido = false;
        }

        // Validar JSON de ações
        try {
            JSON.parse(this.state.acoesJson);
        } catch (e) {
            this.setState({ acoesJsonError: 'JSON inválido. Verifique a sintaxe.' });
            valido = false;
        }

        return valido;
    };

    salvarRegra = async () => {
        if (!this.validarFormulario()) {
            return;
        }

        const { programaId } = this.props;
        const { id, tipos, max_executions, regrasJson, acoesJson } = this.state;

        this.setState({ loadingModal: true });

        const dados = {
            programa_id: programaId,
            tipos: tipos.join(','),
            max_executions: max_executions !== '' ? parseInt(max_executions) : '',
            regras: JSON.parse(regrasJson),
            acoes: JSON.parse(acoesJson),
        };

        const url = id ? `/programas/regras/${id}/` : '/programas/regras/';
        const metodo = id ? 'put' : 'post';

        try {
            await api({
                method: metodo,
                url: url,
                data: dados,
            });

            const MySwal = withReactContent(Swal);
            const textSwal = id ? 'Regra atualizada com sucesso' : 'Regra cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ loadingModal: false });
            this.fecharModal();
            this.carregarRegras(this.state.page_numb);

        } catch (error) {
            let erro_msg = 'Erro ao salvar regra, verifique os campos e tente novamente';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                
                if (campos.tipos) {
                    this.setState({ tiposError: campos.tipos });
                }
                if (campos.max_executions) {
                    this.setState({ maxExecutionsError: campos.max_executions });
                }
                if (campos.regras) {
                    this.setState({ regrasJsonError: campos.regras });
                }
                if (campos.acoes) {
                    this.setState({ acoesJsonError: campos.acoes });
                }
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });

            this.setState({ loadingModal: false });
        }
    };

    excluirRegra = (regra) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Você tem certeza?',
            text: 'Esta ação não pode ser desfeita!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await api.delete(`/programas/regras/${regra.id}/`);

                    MySwal.fire(
                        'Excluído!',
                        'A regra foi excluída com sucesso.',
                        'success'
                    );

                    this.carregarRegras(this.state.page_numb);

                } catch (error) {
                    let erro_msg = 'Erro ao excluir regra';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    }

                    MySwal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: erro_msg,
                    });
                }
            }
        });
    };

    renderRows = () => {
        if ('results' in this.state.listRegras && this.state.listRegras.results.length > 0) {
            return this.state.listRegras.results.map((regra) => (
                <tr key={regra.id}>
                    <td>{regra.id}</td>
                    <td>
                        {regra.tipos && regra.tipos.split(',').map((tipo, index) => (
                            <span 
                                key={index} 
                                className={`badge me-1 ${tipo.trim() === 'auto' ? 'bg-primary' : 'bg-success'}`}
                            >
                                {tipo.trim()}
                            </span>
                        ))}
                    </td>
                    <td>
                        {regra.max_executions != null ? regra.max_executions : <span className="text-muted">Sem limite</span>}
                    </td>
                    <td style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {this.gerarResumoJson(regra.regras)}
                    </td>
                    <td style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {this.gerarResumoJson(regra.acoes)}
                    </td>
                    <td>
                        <Button 
                            variant="light" 
                            size="sm" 
                            className="me-1"
                            onClick={() => this.abrirModalEditar(regra)}
                        >
                            <FaRegEdit /> Editar
                        </Button>
                        <Button 
                            variant="danger" 
                            size="sm"
                            onClick={() => this.excluirRegra(regra)}
                        >
                            <FaTrash /> Excluir
                        </Button>
                    </td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={6}>Nenhuma regra cadastrada para este programa</td>
            </tr>
        );
    };

    render() {
        const { 
            loading, 
            loadingModal,
            error, 
            showModal, 
            modalTitulo,
            tipos,
            max_executions,
            regrasJson,
            acoesJson,
            tiposError,
            maxExecutionsError,
            regrasJsonError,
            acoesJsonError,
            listRegras,
            page_numb,
        } = this.state;

        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h4>Regras do Programa</h4>
                            </Col>
                            <Col sm={6} lg={6} className="text-end">
                                <Button variant="secondary" size="sm" onClick={this.abrirModalNovo}>
                                    <FaPlus /> Adicionar Regra
                                </Button>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Tipos</th>
                                    <th>Max Execuções</th>
                                    <th>Regras</th>
                                    <th>Ações</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={6}>Carregando...</td>
                                    </tr>
                                ) : (
                                    error ? (
                                        <tr>
                                            <td colSpan={6}>{error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>

                        {'results' in listRegras && listRegras.results.length > 0 && 
                            <Paginacao 
                                dados={listRegras} 
                                loading={loading} 
                                page_numb={page_numb} 
                                _onClickPagina={this.onClickPagina} 
                            />
                        }
                    </Card.Body>
                </Card>

                {/* Modal de Cadastro/Edição */}
                <Modal 
                    show={showModal} 
                    onHide={this.fecharModal}
                    size="xl"
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Tipos <span style={{ color: 'red' }}>*</span></Form.Label>
                                <div>
                                    {this.tiposDisponiveis.map((tipo) => (
                                        <Form.Check
                                            key={tipo.value}
                                            inline
                                            type="checkbox"
                                            id={`tipo-${tipo.value}`}
                                            label={tipo.label}
                                            checked={tipos.includes(tipo.value)}
                                            onChange={(e) => this.handleTipoChange(tipo.value, e.target.checked)}
                                        />
                                    ))}
                                </div>
                                {tiposError && (
                                    <Form.Text className="text-danger">{tiposError}</Form.Text>
                                )}
                            </Form.Group>
                            
                            <Form.Group className="mb-3">
                                <Form.Label>Max Execuções</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Deixe em branco para sem limite"
                                    value={max_executions}
                                    onChange={this.handleMaxExecutionsChange}
                                    isInvalid={!!maxExecutionsError}
                                />
                                {maxExecutionsError && (
                                    <Form.Control.Feedback type="invalid">{maxExecutionsError}</Form.Control.Feedback>
                                )}
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Regras (JSON)</Form.Label>
                                {regrasJsonError && (
                                    <Alert variant="danger" className="py-1 mb-2">{regrasJsonError}</Alert>
                                )}
                                <Editor
                                    height="250px"
                                    defaultLanguage="json"
                                    value={regrasJson}
                                    onChange={this.handleRegrasJsonChange}
                                    theme="vs-dark"
                                    options={{
                                        minimap: { enabled: false },
                                        fontSize: 14,
                                        formatOnPaste: true,
                                        formatOnType: true,
                                        automaticLayout: true,
                                        tabSize: 4,
                                    }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Ações (JSON)</Form.Label>
                                {acoesJsonError && (
                                    <Alert variant="danger" className="py-1 mb-2">{acoesJsonError}</Alert>
                                )}
                                <Editor
                                    height="250px"
                                    defaultLanguage="json"
                                    value={acoesJson}
                                    onChange={this.handleAcoesJsonChange}
                                    theme="vs-dark"
                                    options={{
                                        minimap: { enabled: false },
                                        fontSize: 14,
                                        formatOnPaste: true,
                                        formatOnType: true,
                                        automaticLayout: true,
                                        tabSize: 4,
                                    }}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModal}>
                            Cancelar
                        </Button>
                        <Button 
                            variant="success" 
                            onClick={this.salvarRegra}
                            disabled={loadingModal}
                        >
                            {loadingModal ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ProgramaRegras;
